import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-publication-student',
  templateUrl: './publication-student.component.html',
  styleUrls: ['./publication-student.component.css']
})
export class PublicationStudentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  banner: any = {
    pagetitle: "Publication (Student)",
    bg_image: "assets/images/banner/bnr3.jpg",
    title: "Publication (Student)",
  }
}
